import React from 'react';
import ReadCookie from '../../../functions/readcookies';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loading';
import { Grid, Button } from 'semantic-ui-react';
import Add from './add';
import View from './view';

class Mode extends React.Component {

  state = {
    data: []
  }

  componentDidMount() {
    this.getMode();
  }

  getMode() {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    context.setState({
      load: true,
      message: 'Getting Branch Details'
    })
    $.ajax({
      type: 'POST',
      data: { 'userId': userId },
      url: Server() + 'addmenu/mode/get.php',
      success: function(data)
      {
        context.setState({ load: false })
        try {
          data = JSON.parse(data);
          context.setState({ data: data });
        } catch (e) {
          console.log(e);
        }
      },
      error: function(e)
      {
        alert('Try again!!');
        context.setState({
          load: false
        });
      }
    });
  }

  render() {
    return (
      <div style={{padding: '2%'}}>
        <Grid>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <Add menuPermission={this.props.menuPermission} data={this.state.data} getMode={this.getMode.bind(this)} type={'add'} modeledit={this.state.modeledit} />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <View menuPermission={this.props.menuPermission} data={this.state.data} getMode={this.getMode.bind(this)}  modeledit={this.state.modeledit} />
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

export default Mode;
